<template>
  <div class="verification">
    <div v-if="status === 'loading'" class="verification__status">
      Pripravujeme bezpečné overenie klienta…
    </div>
    <div v-else-if="status === 'submitted'" class="verification__status">
      Overenie bolo odoslané a spracúva sa.
    </div>
    <div v-else-if="status === 'completed'" class="verification__result verification__result--success">
      <strong>Overenie je dokončené</strong>
      <span>Výsledok, údaje a fotografie dokladu sa ukladajú ku klientovi.</span>
      <button type="button" @click="$emit('completed')">Zavrieť</button>
    </div>
    <div v-else-if="status === 'error'" class="verification__result verification__result--error">
      <strong>Overenie sa nepodarilo spustiť</strong>
      <span>{{ errorMessage }}</span>
      <button type="button" @click="launch">Skúsiť znova</button>
    </div>

    <div
      v-show="status !== 'completed' && status !== 'error'"
      id="sumsub-websdk-container"
    ></div>
  </div>
</template>

<script>
import snsWebSdk from '@sumsub/websdk';
import { getSumSubToken } from '../../../../../services/brokerService';

export default {
  name: 'ClientVerificationLocal',
  props: {
    user: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      instance: null,
      status: 'loading',
      errorMessage: '',
    };
  },
  mounted () {
    this.launch();
  },
  methods: {
    async getAccessToken () {
      return (await getSumSubToken({ user_id: this.user })).access_token;
    },
    readableError (error) {
      if (typeof error === 'string') return error;
      return error?.message || error?.error || 'Skúste overenie spustiť znova.';
    },
    async launch () {
      this.status = 'loading';
      this.errorMessage = '';
      const container = document.getElementById('sumsub-websdk-container');
      if (this.instance?.destroy) this.instance.destroy();
      if (container) container.innerHTML = '';

      try {
        const accessToken = await this.getAccessToken();
        this.instance = snsWebSdk
          .init(accessToken, () => this.getAccessToken())
          .withConf({ lang: 'sk' })
          .withOptions({ addViewportTag: false, adaptIframeHeight: true })
          .on('idCheck.onReady', () => {
            this.status = 'ready';
          })
          .on('idCheck.onApplicantSubmitted', () => {
            this.status = 'submitted';
          })
          .on('idCheck.onApplicantStatusChanged', payload => {
            if (payload?.reviewStatus === 'completed' || payload?.reviewResult) {
              this.status = 'completed';
              this.$emit('verification-completed', payload);
            }
          })
          .on('idCheck.onApplicantVerificationCompleted', payload => {
            this.status = 'completed';
            this.$emit('verification-completed', payload);
          })
          .on('idCheck.onError', error => {
            console.error('Sumsub WebSDK error', error);
            this.errorMessage = this.readableError(error);
            this.status = 'error';
          })
          .build();
        this.instance.launch('#sumsub-websdk-container');
      } catch (error) {
        console.error('Sumsub launch error', error);
        this.errorMessage = this.readableError(error);
        this.status = 'error';
      }
    },
  },
  beforeDestroy () {
    if (this.instance?.destroy) this.instance.destroy();
  },
};
</script>

<style scoped lang="scss">
.verification {
  min-height: 240px;
}

.verification__status,
.verification__result {
  margin: 12px 0;
  padding: 18px;
  border: 1px solid #d7e6f5;
  border-radius: 12px;
  background: #f5f9fd;
  color: #0a1953;
  text-align: center;
}

.verification__result {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  button {
    min-height: 42px;
    padding: 8px 22px;
    border: 0;
    border-radius: 8px;
    background: #3184d7;
    color: #fff;
    font-weight: 700;
  }
}

.verification__result--error {
  border-color: #f1c7c7;
  background: #fff7f7;
}
</style>
